import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import type { Drone } from '@/types/fleet';

/**
 * Resolves the set of drone ids that belong to the given site.
 * Returns null when no site filter is active (no restriction).
 */
export function useSiteDroneFilter(siteId: string | null) {
  const [allowedDroneIds, setAllowedDroneIds] = useState<Set<string> | null>(null);

  useEffect(() => {
    let cancelled = false;
    const resolve = async (): Promise<Set<string> | null> => {
      if (!siteId) return null;
      try {
        const r = await api.get<{ data: Drone[] }>('/api/drones');
        const ids = new Set<string>();
        for (const d of r.data) {
          if (d.site_id === siteId) ids.add(d.id);
        }
        return ids;
      } catch {
        return new Set<string>();
      }
    };
    resolve().then((ids) => {
      if (!cancelled) setAllowedDroneIds(ids);
    });
    return () => { cancelled = true; };
  }, [siteId]);

  return allowedDroneIds;
}
